import {Component, inject, input, output} from '@angular/core';
import {EventItem} from "../../../common/interfaces";
import {TranslateModule} from "@ngx-translate/core";
import {DatePipe, NgOptimizedImage, TitleCasePipe} from "@angular/common";
import {Router} from "@angular/router";
import {ACTION_ID} from "../../../common/constants";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-new-single-event',
  standalone: true,
  imports: [DatePipe, TranslateModule, NgOptimizedImage, TitleCasePipe],
  templateUrl: './new-single-event.component.html',
  styleUrl: './new-single-event.component.sass'
})
export class NewSingleEventComponent {
  readonly eventItem = input<EventItem>();
  readonly eventClick = output<void>();
  readonly selectEvent = output<number>();

  connId: any = environment.connId;
  private readonly router = inject(Router);

  handleClick(): void {
    const eventItem = this.eventItem();
    if (eventItem && eventItem.eventId) {
      this.selectEvent.emit(eventItem.eventId as number);
      void this.router.navigate([`event/${this.connId}/${eventItem.eventId}/${ACTION_ID.NORMAL}/${eventItem.hashedId}`]);
    }
  }
}
